/**
 * ONE name-matching rule for the frontend, mirrored line for line from
 * backend/src/services/fantasyDataService.js normaliseName(). The backend
 * uses it to decide whether a marked pick matches a player in the pool; the
 * Live Draft tracker's search box has to agree with it, or a name typed as
 * "Jokic" would never find the pool's "Jokić", and a player marked taken as
 * "Marvin Harrison Jr." would still show up in the results.
 *
 * Lower-case, strip accents, strip generational suffixes (Jr, Sr, II to V),
 * strip punctuation and digits, collapse whitespace. Keep the two in step.
 */
export const normaliseName = (n) => {
  if (typeof n !== 'string') return ''
  return n
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // strip accents
    .replace(/\b(jr|sr|ii|iii|iv|v)\b/g, '') // strip generational suffixes
    .replace(/[^a-z\s]/g, '') // strip punctuation and digits
    .replace(/\s+/g, ' ')
    .trim()
}
